export enum ContentType {
  PAGE = 'PAGE',
  VIDEO = 'VIDEO',
  ALBUM = 'ALBUM',
  TRACK = 'TRACK',
  PRODUCT = 'PRODUCT',
  AUDIO = 'AUDIO',
}
